import React from 'react';

import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {type RouteData} from '../types';
import {MARIMO_NOTEBOOK_EDIT_PATH, NOTEBOOKS_PATH} from './notebookPaths';

export const NOTEBOOK_ROUTES_DATA: RouteData[] = [
  {
    // POC placeholder for the shell route claim on `/notebooks`.
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'Notebooks',
    },
    exact: true,
    isPrivateRoute: true,
    path: NOTEBOOKS_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/NotebooksPage')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true,
    },
    exact: true,
    isPrivateRoute: true,
    path: MARIMO_NOTEBOOK_EDIT_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/MarimoNotebookRuntimePage')
    ),
  },
];
